import IndividualTable from "../../../IndividualTable";
import { sampleData } from "../../sampleData";

const Distance70 = () => {
  let winners = [
    "314", "312", "428", "486"
  ];
  return <IndividualTable matchType={"8"} gender="M" event="70" subTitle="Puta" data={sampleData} topRankCount="4" winners={winners} />;
};
export default Distance70;
